module.exports = __webpack_public_path__ + "static/media/arrow-alt-circle-right.53a3f74b.svg";